
import React, { useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import GSSVG from 'smartstream-widgets/controls/GSSVG'

import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { Props } from './types'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme';

const styles = (theme: Theme) =>  createStyles({
  textColorActive: {
    color: theme.palette.primary.main
  },
  textColorInactive: {
    color: theme.palette.text.secondary
  },
  bar: {
    backgroundColor: theme.palette.background.paper
  }
})

export function TabBar (props: Props) {
  const {
    tabElements,
    defaultTab,
    classes,
    indicatorColor = 'primary',
    onTabChange,
    tabClasses,
    tabBarClasses,
    appBarClasses,
    color,
    value: propValue,
    variant = 'fullWidth',
    textColor,
    scrollButtons
  } = props
  let value: string | number
  let setValue

  if (propValue === undefined || propValue === null || (typeof propValue === 'string' && propValue.length === 0)) {
    const defaultIndex = defaultTab || tabElements[0].id
    const [savedValue, setSavedValue] = useState(defaultIndex)
    value = savedValue
    setValue = setSavedValue
  } else {
    value = propValue
  }

  const appBarClass = appBarClasses && appBarClasses.root ? appBarClasses.root : ''

  function handleChange (event: React.SyntheticEvent, newValue: number) {
    setValue && setValue(newValue)
    value !== newValue && onTabChange(newValue)
  }

  const currentTab = tabElements.find(tab => tab.id === value)
  const currentTabName = (currentTab && currentTab.name) || 'tab'

  return (
    <AppBar position='static' color={color} className={`${classes.bar} ${appBarClass}`} data-testid="tab-bar">
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor={indicatorColor}
        textColor={textColor}
        variant={variant}
        classes={tabBarClasses}
        scrollButtons={scrollButtons}
        allowScrollButtonsMobile
      >
        {tabElements.map(element => {
          return (
            <Tab
              data-ht-category='tab'
              data-ht-action={`tab change from ${currentTabName} to ${element.name}`}
              data-ht-label={element.name}
              disableRipple
              value={element.id}
              label={element.name}
              disabled={element.disabled}
              icon={element.icon &&
                <GSSVG xlinkHref={element.icon} />}
              key={element.id}
              className={element.id === value ? classes.textColorActive : classes.textColorInactive}
              classes={tabClasses}
            />
          )
        })}
      </Tabs>
    </AppBar>
  )
}

export default withStyles(styles,{defaultTheme: getDefaultTheme})(TabBar)
